import React from 'react';
import { Navigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import LogoutIcon from '@mui/icons-material/Logout';
import IconButton from '@mui/material/IconButton';
// import { ServiceItem } from './GlobalMenu';

import { authPost, authFetch, logOut } from "./../authProvider";
import { LanguageContext } from './LanguageContext';
import { languageOptions } from './../translations';
import { FeatureTrim } from './FeatureTrim';

//Vakiot
const API_PREFIX = 'api/Simulation/SkenaarioAdvisor';

export class LocalMenu extends React.Component {
    static contextType = LanguageContext;

    constructor(props) {
        super(props);

        this.state = {
            features: [],
            menuOpen: false,
            anchorEl: null,
            searchText: "",
            title: props.title,
            menuItems: props.menuItems,
            selectedId: props.selectedId,
            openAdvisor: false,
            chatBotOutput: "",
            loading: false,
            userInput: "",
            disabled: true,
            textFieldDisabled: false,
            chatHistoryArray: [],
            //TODO: K�ytt�j�n nimi
            Username: "Username",
            aiAdvisor: "AI Advisor",
            parentId: props.parentId || null,
            redirect: null,
            anchorElLang: null,
            isMobile: window.innerWidth < 960
        }
    }

    componentDidMount() {
        // Hae features ja organizations
        if (this.props.pca) {
            authFetch(this.props.pca, 'api/Toiminto/Read')
                .then(response => response.json())
                .then(data => {
                    var features = data.filter(d => d.aktivoitu).map(d => d.toiminto);
                    this.setState({ features: features });
                });

        }

        // Listen for window resize to detect mobile
        this.handleResize = () => {
            const isMobileNow = window.innerWidth < 960;
            this.setState(prevState => {
                return { isMobile: isMobileNow };
            });
        };
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        if (this.handleResize) {
            window.removeEventListener('resize', this.handleResize);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.parentId !== this.props.parentId) {
            this.setState({ parentId: this.props.parentId });
        }
        if (prevProps.selectedId !== this.props.selectedId
            || prevProps.title !== this.props.title) {
            this.setState({
                title: this.props.title,
                menuItems: this.props.menuItems,
                selectedId: this.props.selectedId,
            });
        }
        if (this.state.redirect && this.state.redirect !== prevState.redirect) {
            this.setState({ redirect: null });
        }
    }

    handleOpen = (e) => {
        this.setState({
            menuOpen: true,
            anchorEl: e.currentTarget
        })
    };

    handleClose = (e) => {
        this.setState({
            menuOpen: false,
            anchorEl: null
        })
    };

    handleSelect = value => event => {
        this.props.onSelectChange(value);
        this.handleClose();
    }

    handleAdvisorWindowOpen = () => {
        this.setState({
            openAdvisor: true
        })
    }

    handleAdvisorWindowClose = () => {
        this.setState({
            openAdvisor: false
        })
    }

    handleError = (error) => {
        const { onError } = this.props;

        var title = '', body = ''
        if (error === 4) {
            title = this.context.dictionary.ErrorDialog.Error4.title;
            body = this.context.dictionary.ErrorDialog.Error4.body;
        } else if (error === 5) {
            title = this.context.dictionary.ErrorDialog.Error5.title;
            body = this.context.dictionary.ErrorDialog.Error5.body;
        } else {
            title = this.context.dictionary.ErrorDialog.Error.title;
            body = this.context.dictionary.ErrorDialog.Error.body;
        }

        onError(title, body);
    }

    handleDeleteHistory = () => {

        this.setState({
            chatHistoryArray: []
        });
    }

    handleOnClick = () => {

        this.state.chatHistoryArray.push(this.state.userInput);
        this.ClearTextField();

        this.handleSendQuery();
    }

    ClearTextField = () => {

        this.setState({
            userInput: "",
            textFieldDisabled: true,
            loading: true,
            disabled: true
        });
    }

    handleSendQuery = () => {

        var FetchedData;
        authPost(this.props.pca, API_PREFIX + '/Chat', {
            body: JSON.stringify({
                chatHistoryArray: JSON.stringify(this.state.chatHistoryArray)
            })
        })
            .then(response => response.text())
            .then(data => {
                if ((data || {}).error) {
                    this.handleError(data.error);
                }
                else {
                    FetchedData = data;
                }
                this.setState({
                    chatBotOutput: FetchedData
                }, () => this.setReceivedData());
            })

    }

    setReceivedData = () => {

        this.state.chatHistoryArray.push(this.state.chatBotOutput);

        this.setState({
            loading: false,
            textFieldDisabled: false
        });
    }

    handleHelp = (value, pageid) => {
        this.setState({
            parentId: value,
            redirect: "/help" + (pageid ? "/?path=" + pageid : "")
        });
    }

    handleDocuments = (value, folderid) => {
        this.setState({
            parentId: value,
            redirect: "/tiedostot" + (folderid ? "/?parent=" + folderid : "")
        });
    }

    handleLogout = () => {
        logOut(this.props.pca);
    }

    handleLanguageChange = (event) => {
        const { userLanguageChange } = this.context;
        this.setState({ anchorElLang: null });
        userLanguageChange((event.currentTarget.dataset || {}).lang)
    };

    handleOpenLangMenu = (event) => {
        this.setState({ anchorElLang: event.currentTarget });
    };

    handleCloseLangMenu = () => {
        this.setState({ anchorElLang: null });
    }

    render() {
        const { userLanguage, dictionary } = this.context;
        const { onlyTopLevel } = this.props;
        const { title, menuItems, selectedId, menuOpen, anchorEl, redirect, parentId, features, isMobile } = this.state;

        const report = (menuItems || []).filter(d => (d.id === selectedId))[0] || {};

        const navigateToUrl = (url) => {
            if (url) {
                if (url.startsWith("http")) {
                    window.location.href = url;
                    return null;
                } else {
                    return (<Navigate to={url} />);
                }
            } else {
                return null;
            }
        }

        return (
            <React.Fragment>
                {navigateToUrl(redirect)}
                {/* Mobile: Transparent AppBar showing title and info */}
                {isMobile && (
                    <>
                        <AppBar 
                            elevation={0} 
                            sx={{ 
                                background: "transparent", 
                                height: 64, 
                                paddingLeft: 0,
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                zIndex: 1200
                            }}
                        >
                            <Toolbar style={{ minHeight: 56, paddingLeft: 8, paddingRight: 8 }}>
                                {/* Title and menu items */}
                                <Box sx={{ width: 40, height: 40 }} />
                                <Typography 
                                    style={{ 
                                        color: "#fff", 
                                        fontWeight: "bold",
                                        marginLeft: 8
                                    }} 
                                    variant="subtitle1" 
                                    component="div"
                                >
                                    {title}
                                </Typography>

                                {menuItems && !onlyTopLevel && menuItems.length > 0 && (
                                    <>
                                        <NavigateNextIcon 
                                            fontSize="small" 
                                            sx={{ marginLeft: 1, marginRight: 1, width: 20, color: "#fff" }} 
                                        />
                                        <div
                                            onClick={this.handleOpen}
                                            style={{ 
                                                flex: 1,
                                                maxWidth: 200,
                                                display: "flex", 
                                                borderRadius: 9999, 
                                                backgroundColor: "rgba(255, 255, 255, 0.9)",
                                                padding: "4px 8px",
                                                alignItems: "center"
                                            }}
                                        >
                                            <Typography 
                                                style={{ 
                                                    color: "#212121", 
                                                    fontWeight: "bold",
                                                    fontSize: "12px",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap"
                                                }} 
                                                variant="caption" 
                                                component="div"
                                            >
                                                {report.name}
                                            </Typography>
                                            {menuItems.length > 1 && (
                                                <div style={{ marginLeft: 4 }}>
                                                    {menuOpen ? (
                                                        <ExpandLess sx={{ width: 20, color: "#212121" }} />
                                                    ) : (
                                                        <ExpandMore sx={{ width: 20, color: "#212121" }} />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </>
                                )}
                                <Box sx={{ flexGrow: 1 }} />
                                {isMobile && (
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: 50
                                        }}
                                    >
                                        <img
                                            src={"/images/logo/Karpon_K.png"}
                                            style={{ width: 50, height: 50 }}
                                            alt="Karpon Logo"
                                        />
                                    </Box>
                                )}
                                <Box sx={{ flexGrow: 1 }} />

                                {/* AI Advisor button for mobile */}
                                <Tooltip title={dictionary.LocalMenu.Advisor.Title}>
                                    <IconButton
                                        onClick={() => this.setState({ openAdvisor: !this.state.openAdvisor })}
                                        sx={{
                                            backgroundColor: "transparent",
                                            color: "#fff",
                                            "&:hover": {
                                                backgroundColor: "rgba(255, 255, 255, 0.1)"
                                            },
                                            padding: 1
                                        }}
                                    >
                                        <img 
                                            src={"/images/logo/ai-advisor-icon.png"} 
                                            style={{ width: 60, height: 60 }} 
                                            alt="ai-advisor" 
                                        />
                                    </IconButton>
                                </Tooltip>
                            </Toolbar>
                        </AppBar>

                        {/* Menu dropdown for mobile */}
                        {menuItems && !onlyTopLevel && menuItems.length > 1 && (
                            <Menu 
                                anchorEl={anchorEl} 
                                open={menuOpen} 
                                onClose={this.handleClose}
                                PaperProps={{
                                    sx: {
                                        width: 200,
                                        maxWidth: '80%'
                                    }
                                }}
                            >
                                {(menuItems || []).map((d) => (
                                    <MenuItem 
                                        key={d.id} 
                                        value={d.id} 
                                        sx={{ 
                                            backgroundColor: (d.id === selectedId) ? "#ddd" : "inherit"
                                        }} 
                                        onClick={this.handleSelect(d.id)}
                                    >
                                        {d.name}
                                    </MenuItem>
                                ))}
                            </Menu>
                        )}
                    </>
                )}
                {/* Desktop: Normal AppBar */}
                {!isMobile && (
                <AppBar elevation={4} style={{ background: "#3C495A", height: 64, paddingLeft: 58 }}>
                <Toolbar style={{ minHeight: 56 }}>
                    <Typography style={{ color: "#fff", fontWeight: "bold" }} variant="subtitle1" component="div">
                        {title}
                    </Typography>

                    {menuItems && !onlyTopLevel ? (
                        <div style={{ display: "flex" }}>
                            <NavigateNextIcon fontSize="small" sx={{ margin: "auto", width: 24, color: "#fff" }} />
                            <div
                                onClick={this.handleOpen}
                                style={{ width: 380, display: "flex", borderRadius: 9999, backgroundColor: "#fff" }}
                                sx={{ textTransform: "none" }}
                            >
                                <Typography style={{ marginLeft: 6, paddingLeft: 8, paddingTop: 4, color: "#212121", fontWeight: "bold" }} variant="subtitle1" component="div">
                                    {report.name}
                                </Typography>
                                <Box sx={{ flexGrow: 1 }} />
                                {menuItems.length > 1 ? (
                                    <div style={{ paddingTop: 4 }}>
                                        {menuOpen ? <ExpandLess sx={{ margin: "auto", width: 24, color: "#212121" }} /> : <ExpandMore sx={{ width: 24, color: "#212121" }} />}
                                    </div>
                                ) : null}
                            </div>
                            <Menu anchorEl={anchorEl} open={menuOpen} onClose={this.handleClose}>
                                {(menuItems || []).map((d) => (<MenuItem key={d.id} value={d.id} sx={{ width: 380, backgroundColor: (d.id === selectedId) ? "#ddd" : "inherit" }} onClick={this.handleSelect(d.id)}>{d.name}</MenuItem>))}
                            </Menu>
                        </div>
                    ) : null}

                    <Box sx={{ flexGrow: 1 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <MenuList
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: 0,
                                backgroundColor: 'transparent',
                                '& .MuiMenuItem-root': {
                                    margin: 0,
                                    borderRadius: '12px',
                                    width: 'auto'
                                },
                                '& .MuiListItemIcon-root': {
                                    minWidth: 0,
                                },
                                '& .textLabel': {
                                    display: 'none'
                                },
                                '& .badgeLabel': {
                                    display: 'none'
                                }
                            }}
                        >
                            <FeatureTrim features={this.state.features} feature={"UI_Tiedosto_Luku"}>
                                <Tooltip title={dictionary.GlobalMenu.Reportdocuments}>
                                    <span style={{ display: 'inline-flex' }}>
                                                {/* <ServiceItem
                                        //     id={9991}
                                        //     title={dictionary.GlobalMenu.Reportdocuments}
                                        //     icon="FeedIcon"
                                        //     onClick={this.handleDocuments}
                                        //     selected={parentId === 9991}
                                        //     ariaLabel={dictionary.GlobalMenu.Reportdocuments}
                                        //     sx={{
                                        //         backgroundColor: 'transparent'
                                        //     }}
                                        // />
                                        */}
                                    </span>
                                </Tooltip>
                            </FeatureTrim>
                            <FeatureTrim features={this.state.features} feature={"UI_Etusivu_Luku"}>
                                <Tooltip title={dictionary.GlobalMenu.Help}>
                                    <span style={{ display: 'inline-flex' }}>
                                                {/* <ServiceItem
                                        //     id={9992}
                                        //     title={dictionary.GlobalMenu.Help}
                                        //     icon="HelpIcon"
                                        //     onClick={this.handleHelp}
                                        //     selected={parentId === 9992}
                                        //     ariaLabel={dictionary.GlobalMenu.Help}
                                        //     sx={{
                                        //         backgroundColor: 'transparent'
                                        //     }}
                                        // />*/}
                                    </span>
                                </Tooltip>
                            </FeatureTrim>
                        </MenuList>

                        {/* Kirjaudu ulos */}
                        <Tooltip title={dictionary.GlobalMenu.Logout}>
                            <MenuItem
                                onClick={this.handleLogout}
                                sx={{
                                    color: "#fff",
                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                                }}
                            >
                                <LogoutIcon />
                            </MenuItem>
                        </Tooltip>

                        {/* Kieli */}
                        <Tooltip title={dictionary.displayName}>
                            <MenuItem
                                onClick={this.handleOpenLangMenu}
                                sx={{
                                    color: "#fff",
                                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
                                }}
                            >
                                <Typography style={{ color: "#fff", fontSize: "14px", fontWeight: "bold" }}>
                                    {dictionary.GlobalMenu.LanguageShort}
                                </Typography>
                            </MenuItem>
                        </Tooltip>

                        <Menu
                            sx={{ mt: '45px' }}
                            id="menu-appbar-lang"
                            anchorEl={this.state.anchorElLang}
                            open={Boolean(this.state.anchorElLang)}
                            onClose={this.handleCloseLangMenu}
                        >
                            {Object.entries(languageOptions).map(([id, name]) => (
                                <MenuItem key={id} data-lang={id} selected={userLanguage === id} onClick={this.handleLanguageChange}>
                                    <Typography textAlign="center" style={{ color: "#303030" }}>{name}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>

                        <Tooltip title={dictionary.LocalMenu.Advisor.Title}>
                            <IconButton
                                style={{ marginTop: 24, marginRight: -16 }}
                                onClick={() => this.setState({ openAdvisor: !this.state.openAdvisor })}
                            >
                                <img src={"/images/logo/ai-advisor-icon.png"} style={{ width: 64, height: 64 }} alt="ai-advisor" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Toolbar >
            </AppBar >
                )}
                {/* AI Advisor Dialog - shown in both mobile and desktop */}
                <Dialog
                    hideBackdrop
                    disableEnforceFocus
                    fullScreen={isMobile}
                    sx={{
                        '& .MuiDialog-paper': isMobile ? {
                            width: '100%',
                            maxWidth: '100%',
                            height: '100vh',
                            margin: 0,
                            borderRadius: 0
                        } : {
                            position: 'fixed',
                            top: 60,
                            right: 0,
                            width: 325,
                            maxWidth: 325,
                            height: 500
                        }
                    }}
                    open={this.state.openAdvisor}
                >
                            <DialogTitle>
                                {dictionary.LocalMenu.Advisor.Title}
                            </DialogTitle>
                            <DialogContent
                                sx={{
                                    padding: "8px",
                                }}
                            >
                                <Box
                                    id="chatArea"
                                    sx={{
                                        width: "100%",
                                        height: "calc(100% - 80px)",
                                        overflow: "auto",
                                        display: "flex",
                                        flexDirection: "column-reverse",
                                        gap: "10px 20px"
                                    }}>
                                    <List>
                                        {this.state.chatHistoryArray.map((chatBox, index) => {

                                            if (index % 2 === 0) {
                                                return (
                                                    <React.Fragment>
                                                        <ListItem>
                                                            <ListItemText primary={this.state.Username} secondary={<Typography
                                                                sx={{
                                                                    color: "#403e3e",
                                                                    bgcolor: "whitesmoke",
                                                                    borderRadius: "5px",
                                                                    padding: "5px",
                                                                    boxShadow: 2,
                                                                    flexDirection: "row",
                                                                    wordBreak: "break-word"
                                                                }}
                                                            >{chatBox}</Typography>}
                                                                sx={{
                                                                    textAlign: "right",
                                                                    alignItems: "flex-end",
                                                                    display: "flex",
                                                                    flexDirection: "column"
                                                                }} />
                                                            <ListItemAvatar
                                                                sx={{
                                                                    alignSelf: "flex-start",
                                                                    display: "flex",
                                                                    flexDirection: "row-reverse"
                                                                }}>
                                                                <Avatar />
                                                            </ListItemAvatar>
                                                        </ListItem>
                                                    </React.Fragment>
                                                );
                                            }

                                            else {
                                                return (
                                                    <React.Fragment>
                                                        <ListItem>
                                                            <ListItemAvatar sx={{ alignSelf: "flex-start" }}>
                                                                <Avatar src={"/images/logo/ai-advisor-icon.png"} />
                                                            </ListItemAvatar>
                                                            <ListItemText primary={this.state.aiAdvisor} secondary={<Typography
                                                                sx={{
                                                                    color: "white",
                                                                    bgcolor: "#3C495A",
                                                                    borderRadius: "5px",
                                                                    padding: "5px",
                                                                    boxShadow: 2,
                                                                    flexDirection: "row",
                                                                    wordBreak: "break-word"
                                                                }}
                                                            >{chatBox}</Typography>}
                                                                sx={{
                                                                    alignItems: "flex-start",
                                                                    display: "flex",
                                                                    flexDirection: "column"
                                                                }}
                                                            />
                                                        </ListItem>
                                                    </React.Fragment>
                                                );
                                            }
                                        })}
                                    </List>
                                </Box>

                                <Box
                                    sx={{
                                        display: "flex",
                                        height: 53,
                                    }}>
                                    <TextField
                                        fullWidth
                                        label={dictionary.LocalMenu.Advisor.InputLabel}
                                        value={this.state.userInput}
                                        variant="standard"
                                        disabled={this.state.textFieldDisabled}
                                        onChange={(e) =>
                                            this.setState({
                                                userInput: e.target.value,
                                                disabled: false
                                            })
                                        }
                                        onKeyPress={(e) => {
                                            if (e.key === "Enter") {
                                                if (this.state.userInput) this.handleOnClick();
                                            }
                                        }}
                                    />

                                    <IconButton
                                        size="large"
                                        color="primary"
                                        disabled={this.state.disabled}
                                        onClick={this.handleOnClick}
                                    >{this.state.loading ? (
                                        <CircularProgress />
                                    ) : (
                                        <SendIcon />
                                    )}
                                    </IconButton>
                                </Box>
                            </DialogContent>

                            {/* TODO:THEME */}
                            <DialogActions
                                style={{ backgroundColor: "#3C495A" }}
                            >
                                <ButtonGroup variant="comboButton">
                                    <Button variant="Secondary" disabled={this.state.loading} onClick={this.handleDeleteHistory}>
                                        {dictionary.Clear}
                                    </Button>
                                    <Button variant="Primary" onClick={this.handleAdvisorWindowClose}>
                                        {dictionary.Close}
                                    </Button>
                                </ButtonGroup>
                            </DialogActions>
                        </Dialog>
            </React.Fragment>
        );
    }
}
